import { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faMapMarkerAlt,
  faEnvelope,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";

import ProfileContactForm from "./ProfileContactForm"; // adjust the path as needed

const ContactDetails = ({ resourceDetails }) => {
  const [showModal, setShowModal] = useState(false);

  const handleShowEditModal = () => setShowModal(true);
  const handleCloseEditModal = () => setShowModal(false);

  return (
    <>
      <div className="d-flex align-items-center flex-wrap">
        {/* Info Block */}
        <div className="d-flex text-muted flex-wrap gap-3 p-3">
          <small className="me-3">
            <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2" />
            {[
              resourceDetails?.contact_details?.city_name || "Not found",
              resourceDetails?.contact_details?.state_name || "Not found",
              resourceDetails?.contact_details?.country_name || "Not found",
            ].join(", ")}
          </small>

          <small className="me-3">
            <FontAwesomeIcon icon={faEnvelope} className="me-2" />
            {resourceDetails?.contact_details?.user_email || "Not found"}
          </small>

          <small>
            <FontAwesomeIcon icon={faPhone} className="me-2" />
            {resourceDetails?.contact_details?.mobile || "Not found"}
          </small>
        </div>

        {/* Edit Icon */}
        <div>
          <FontAwesomeIcon
            icon={faEdit}
            className="text-primary"
            role="button"
            title="Edit Contact"
            onClick={handleShowEditModal}
          />
        </div>
      </div>

      {/* Modal with ProfileContactForm */}
      <Modal
        show={showModal}
        onHide={handleCloseEditModal}
        centered
        backdrop="static"
        scrollable
        size="lg"
      >
        <Modal.Header>
          <span className="fw-bold-custom">Edit Contact Information</span>
        </Modal.Header>
        <Modal.Body>
          <ProfileContactForm
            resourceDetails={resourceDetails}
            resourceSlug={resourceDetails?.user_slug}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="dark" size="sm" onClick={handleCloseEditModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ContactDetails;
